const facilityPropertyNames = ["Facility Name"];
const practitionerPropertyNames = ["Last Name", "First Name", "Middle Initial", "Name Suffix"];
const existingProviderPropertyNames = [...facilityPropertyNames, ...practitionerPropertyNames];

export const hiddenPropertiesFor = () => {
    return [];
}

export const displayOnlyPropertiesFor = () => {
    return ["NPI", "TIN", "Line of Service"];
}

export const predefinedOptionPropertiesFor = () => {
    return [];
}